import {useContext, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import "../styles/CourseDetailsPage.css";
import CourseRegistrationForm from "../Forms/CourseRegistrationForm.jsx";
import LoadingScreen from "../components/LoadingScreen";
import AuthContext from "../contexts/AuthContext";

function CourseDetailsPage() {
    const {id} = useParams();
    const [activeTab, setActiveTab] = useState("tanitim");
    const [showRegistrationForm, setShowRegistrationForm] = useState(false);
    const [isRegistered, setIsRegistered] = useState(null);
    const navigate = useNavigate();
    const {user} = useContext(AuthContext);
    const today = new Date();
    const [courseDetails, setCourseDetails] = useState(null);
    const [schedule, setSchedule] = useState([]);
    const [course, setCourse] = useState(null);
    const regEndDate = course ? new Date(course.registrationEndDate) : null;
    const isRegisterEnded = regEndDate && regEndDate < today;
    const endDate = course ? new Date(course.endDate) : null;
    const isCourseEnded = endDate && endDate < today;


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courses/getbyid/${id}`)
            .then(res => res.json())
            .then(data => setCourse(data))
            .catch(err => console.error("Kurs verisi alınamadı:", err));
    }, [id]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courses/${id}/schedule`)
            .then(res => res.json())
            .then(data => setSchedule(data))
            .catch(err => console.error("Ders programı alınamadı:", err));
    }, [id]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/courses/${id}/details`)
            .then(res => res.json())
            .then(data => setCourseDetails(data))
            .catch(err => console.error("Detay alınamadı:", err));
    }, [id]);

    const handleRegisterClick = () => {
        if (user) {
            setShowRegistrationForm(true);
        } else {
            alert("Kursa kayıt olmak için önce giriş yapmalısınız.");
            navigate("/login");
        }
    };

    const handleCloseRegistrationForm = () => {
        setShowRegistrationForm(false);
    };

    useEffect(() => {
        const checkIfRegistered = async () => {
            const email = localStorage.getItem("userEmail");

            if (!email) {
                setIsRegistered(false);
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/course-participants/getByUserEmailAndCourse`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ email: email, courseId: id })
                });

                if (response.ok) {
                    const userData = await response.json();
                    // Kullanıcı verisi varsa kayıt durumunu döndür (enabled true/false)
                    // Kullanıcı verisi yoksa null döndür (kayıt olmamış)
                    setIsRegistered(userData ? userData : null);
                } else {
                    // Kullanıcı bulunamadı
                    setIsRegistered(null);
                }
            } catch (err) {
                console.error("Kayıt kontrolü hatası:", err);
                setIsRegistered(null);
            }
        };

        checkIfRegistered();
    }, [id]);

    if (!course) return <h2>Course not found</h2>;
    if (!courseDetails) return <LoadingScreen/>;

    return (
        <div className="course-details-container">
            <div className="design-container">
                <div className="col-md-7 bg-white details-section">
                    <h2>{course.name}</h2>
                    <p className="lead">{course.description}</p>

                    <div className="tabs">
                        <button className={activeTab === "tanitim" ? "active" : ""} onClick={() => setActiveTab("tanitim")}>Tanıtım</button>
                        <button className={activeTab === "hedef" ? "active" : ""} onClick={() => setActiveTab("hedef")}>Eğitim Hedefi ve Katılımcı Profili</button>
                        <button className={activeTab === "ders" ? "active" : ""} onClick={() => setActiveTab("ders")}>Ders Programı</button>
                        <button className={activeTab === "bilgi" ? "active" : ""} onClick={() => setActiveTab("bilgi")}>Bilgi Formu</button>
                    </div>

                    <div className="tab-content">
                        {activeTab === "tanitim" && <p>{courseDetails.introduction}</p>}

                        {activeTab === "hedef" && (
                            <>
                                <h2>Eğitim Hedefi</h2>
                                <p>{courseDetails.objective}</p>

                                <h2>Hedef Kitle</h2>
                                <ul>
                                    {[1,2,3,4,5].map(i => courseDetails[`targetAudience${i}`] && <li key={`ta${i}`}>{courseDetails[`targetAudience${i}`]}</li>)}
                                </ul>

                                <h2>Neden Katılmalısın?</h2>
                                <ul>
                                    {[1,2,3,4,5].map(i => courseDetails[`reasonsToJoin${i}`] && <li key={`rj${i}`}>{courseDetails[`reasonsToJoin${i}`]}</li>)}
                                </ul>
                            </>
                        )}

                        {activeTab === "bilgi" && (
                            <>
                                <h2>Bu Kursta Neler Öğreneceksiniz?</h2>
                                <ul>
                                    {[1,2,3,4,5].map(i => courseDetails[`learningOutcome${i}`] && <li key={`lo${i}`}>{courseDetails[`learningOutcome${i}`]}</li>)}
                                </ul>
                            </>
                        )}

                        {activeTab === "ders" && <>
                            <table className="table schedule-table" style={{
                                width: '100%',
                                borderCollapse: 'separate',
                                borderSpacing: 0,
                                background: '#f8fafc',
                                borderRadius: '12px',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
                            }}>
                                <thead>
                                <tr style={{background: '#2b6cb0', color: '#fff'}}>
                                    <th style={{padding: '12px', borderTopLeftRadius: '12px'}}>Hafta</th>
                                    <th style={{padding: '12px'}}>Konular</th>
                                    <th style={{padding: '12px'}}>Tarih</th>
                                    <th style={{padding: '12px', borderTopRightRadius: '12px'}}>Gün</th>
                                </tr>
                                </thead>
                                <tbody>
                                {schedule.map((item, index) => (
                                    <tr key={index} style={{background: index % 2 === 0 ? '#e6f0fa' : '#fff'}}>
                                        <td style={{
                                            padding: '10px',
                                            color: '#2d3748',
                                            fontWeight: 500
                                        }}>{item.week}</td>
                                        <td style={{padding: '10px', color: '#4a5568'}}>{item.topic}</td>
                                        <td style={{padding: '10px', color: '#4a5568'}}>{item.date}</td>
                                        <td style={{padding: '10px', color: '#3182ce', fontWeight: 500}}>{item.day}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </>}
                    </div>
                </div>

                <div className="col-md-5 course-info-container">
                    <img src="/images/mamografi_drawing.jpg" alt={course.title} className="course-image" />
                    <div className="info-card">
                        {
                         isRegistered && isRegistered.enabled === true ? (
                             // Kayıt onaylanmış - Ders içeriğine erişebilir
                             <button
                                 onClick={() => navigate(`/course-content/${id}`)}
                                 disabled={isCourseEnded}
                                 className="btn-register"
                             >
                                 {isCourseEnded ? 'Eğitim Süresi Sona Erdi' : 'Ders İçeriğini Gör'}
                             </button>
                         ) : isRegistered && isRegistered.enabled === false ? (
                             // Kayıt yapılmış ama henüz onaylanmamış
                             <button
                                 disabled={true}
                                 className="btn-register disabled"
                             >
                                 Kayıt Onayı Bekleniyor
                             </button>
                         ) : (
                             // Kayıt yapılmamış
                             <button disabled={isRegisterEnded} onClick={handleRegisterClick} className="btn-register">
                                 {isRegisterEnded ? 'Kayıt Kapandı' : 'Kayıt Ol'}
                             </button>
                         )}
                        <div className="info-item"><strong>Kayıt Dönemi:</strong> {course.registrationStartDate} - {course.registrationEndDate}</div>
                        <div className="info-item"><strong>Eğitim Dönemi:</strong> {course.startDate} - {course.endDate}</div>
                        <div className="info-item"><strong>Kontenjan:</strong> {course.capacityMin} - {course.capacityMax}</div>
                        <div className="info-item"><strong>Eğitim Dili:</strong> {course.language}</div>
                        <div className="info-item"><strong>Eğitim Süresi:</strong> {course.duration}</div>
                        <div className="info-item"><strong>Belge Türü:</strong> {course.certificateType}</div>
                        <div className="info-item"><strong>Eğitim Kodu:</strong> {course.courseCode}</div>
                        <div className="info-item"><strong>Koordinatör:</strong> {course.coordinator}</div>
                    </div>
                </div>
            </div>

            {/* Registration Modal */}
            {showRegistrationForm && (
                <CourseRegistrationForm
                    onClose={handleCloseRegistrationForm}
                    courseId={id}
                    courseName={course.title || course.name}
                />
            )}
        </div>
    );
}

export default CourseDetailsPage;